import { getDatetimeOrdinalSuffix } from '@/common/helpers';
import { DateTime } from 'luxon';

export const formatReportedAt = (reportedAt: string) => {
  const timestamp = DateTime.fromISO(reportedAt, { zone: 'America/Winnipeg' });
  // time in am/pm format
  const format1 = timestamp.toFormat('h:mm');
  // Remove all periods and make lowercase for am/pm
  const format2 = timestamp.toFormat('a').replace(/\./g, '');

  // day
  const format3 = timestamp.toFormat('EEEE d');
  const format4 = getDatetimeOrdinalSuffix(timestamp.day);

  // month
  const format5 = timestamp.toFormat('MMMM');

  return `${format1}${format2}, ${format3}${format4} ${format5}`;
};

export const formatDateTimeWithYear = (dateTime: string) => {
  const timestamp = DateTime.fromISO(dateTime, { zone: 'America/Winnipeg' });
  const format1 = timestamp.toFormat('h:mm');
  const format2 = timestamp.toFormat('a').replace(/\./g, '').toUpperCase();

  const format3 = timestamp.toFormat('DDDD');

  return `${format1} ${format2}, ${format3}.`;
};
